import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { fetchTypeaheadProductsByLicenseManufacturers, clearTypeahed } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class ProductTitleTypeahead extends Component {
    static propTypes = {
        fetchTypeaheadProductsByLicenseManufacturers: PropTypes.func.isRequired,
        clearTypeahed: PropTypes.func.isRequired,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        renderMultiSuggestion: PropTypes.func,
        suggestions: PropTypes.array,
        licenseManufacturers: PropTypes.array
    };

    static defaultProps = {
        suggestions: [],
        renderMultiSuggestion
    };

    handleSuggestionsFetchRequested = term => {
        this.props.fetchTypeaheadProductsByLicenseManufacturers(ProductTitleTypeahead.name, {
            term,
            values: this.props.licenseManufacturers
        });
    };

    render() {
        const options = this.props.suggestions.map(productTitle => ({
            label: productTitle.name,
            value: productTitle.ids,
        }));
        return (
            <MultiTypeahead
                options={options}
                isMulti
                value={this.props.value}
                titleId="productName"
                animatedPlaceholder
                handleSuggestionsClearRequested={this.props.clearTypeahed}
                handleSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                onChangeSuggestion={this.props.onChangeSuggestion}
                formatOptionLabel={this.props.renderMultiSuggestion}
                error={this.props.error}
                t={this.props.t}
            />
        );
    }
}
const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === ProductTitleTypeahead.name
            ? typeahead.list
            : ProductTitleTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchTypeaheadProductsByLicenseManufacturers,
    clearTypeahed
})(ProductTitleTypeahead);
